import { ThemeProvider, createTheme } from "@mui/material";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppContextProvider } from "AppContext";
import Routers from "Routers";
import { BrowserRouter } from "react-router-dom";
import "./App.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 15 * 60 * 1000,
    },
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: "#006580",
    },
    secondary: {
      main: "#63A387",
    },
  },
});

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE);

function App() {
  return (
    <AppContextProvider>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routers />
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </AppContextProvider>
  );
}

export default App;
